/* Isolated draft candidate. No endpoint/consent is enabled by this file. */
(function (window, document) {
  'use strict';
  if (window.NatuWhatsAppBridge) return;
  var PHONE = '5564999480738';
  var pending = null;
  var api = null;
  function config() { return window.NATU_ATTRIBUTION_CONFIG || {}; }
  function consent() { try { return typeof config().consentGranted === 'function' && config().consentGranted() === true; } catch (_) { return false; } }
  function client() {
    if (config().enabled !== true || !consent() || !window.NatuAttributionCandidate) return null;
    if (!api) api = window.NatuAttributionCandidate.create({
      enabled: true, endpoint: config().endpoint, allowedEndpoint: config().allowedEndpoint,
      catalog: config().catalog || {}, timeoutMs: config().timeoutMs || 5000,
      consentGranted: consent, storage: window.sessionStorage,
      randomUUID: function () { return window.crypto.randomUUID(); }, fetchImpl: window.fetch.bind(window)
    });
    return api;
  }
  function capture() { try { var c = client(); if (c) c.capture(window.location.search); } catch (_) {} }
  async function requestKey(message) {
    var bytes = new TextEncoder().encode(message);
    var digest = await window.crypto.subtle.digest('SHA-256', bytes);
    var hash = Array.from(new Uint8Array(digest), function (x) { return x.toString(16).padStart(2, '0'); }).join('');
    var slot = 'natu_attr_intent_' + hash;
    var key = window.sessionStorage.getItem(slot);
    if (!key || !/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(key)) {
      key = window.crypto.randomUUID(); window.sessionStorage.setItem(slot, key);
    }
    return key;
  }
  function status(value, anchor) {
    if (value === 'unconfirmed') {
      var note = document.querySelector('[data-natu-attribution-status]');
      if (!note) { note = document.createElement('p'); note.setAttribute('data-natu-attribution-status', ''); note.setAttribute('role', 'status'); (anchor && anchor.parentNode ? anchor.parentNode : document.body).appendChild(note); }
      note.textContent = 'A origem não foi registrada. Seu pedido e suas observações foram preservados.';
    }
  }
  function send(message, options) {
    options = options || {};
    if (typeof message !== 'string' || !message.trim()) return Promise.reject(new Error('MESSAGE_REQUIRED'));
    if (options.anchor && options.anchor.closest('[data-nc-v21-checkout-disabled="true"]')) return Promise.resolve(false);
    if (pending) return pending;
    // Reserve at most one popup in the original user gesture. No navigation until the final message exists.
    var popup = null;
    if (options.newWindow) { try { popup = window.open('about:blank', '_blank'); if (popup) popup.opener = null; } catch (_) {} }
    var job = (async function () {
      var result = { message: message, tracking: 'disabled' };
      try {
        var c = client();
        if (c) {
          var key = await requestKey(message);
          if (consent()) result = await c.decorateMessage(message, key, window.location.search);
        }
      } catch (_) { result = { message: message, tracking: 'unconfirmed' }; }
      // Consent can change while waiting. A returned code is then discarded, never appended.
      if (!consent()) result.message = message;
      status(result.tracking, options.anchor);
      var url = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(result.message);
      if (popup && !popup.closed) popup.location.replace(url);
      else window.location.assign(url);
      return true;
    })();
    pending = job;
    job.finally(function () { if (pending === job) pending = null; }).catch(function () {});
    return job;
  }
  // Runtime capture gates run before this bubble listener, regardless of registration order.
  document.addEventListener('click', function (event) {
    if (config().enabled !== true || event.defaultPrevented) return;
    var link = event.target && event.target.closest && event.target.closest('a[data-nc-v21-wa]');
    if (!link || link.closest('[data-nc-v21-checkout-disabled="true"]')) return;
    var url;
    try { url = new URL(link.href); } catch (_) { return; }
    if (url.origin !== 'https://wa.me' || url.pathname !== '/' + PHONE || !url.searchParams.has('text')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    send(url.searchParams.get('text'), { anchor: link, newWindow: link.target === '_blank' }).catch(function () {});
  });
  document.addEventListener('visitorConsentCollected', capture);
  window.NatuWhatsAppBridge = Object.freeze({ send: send, capture: capture });
  capture();
})(window, document);
